import { TertiaryButton } from '@procurify/ui'
import styled from 'styled-components'

export const GuidedIntakePromoBannerCtaStyled = styled(TertiaryButton)`
  &,
  &:hover,
  &:active {
    background: transparent;
    border: 1px solid ${(props) => props.theme.colors.alert.ai.background};
    box-shadow: none;
    font-weight: ${(props) => props.theme.fontWeights.semibold};
  }
`
